module.exports = __webpack_public_path__ + "static/media/pin-success-viajes.0e30579c.png";